module.exports = __webpack_public_path__ + "4952d5bf33f73b27ccfe260531eb66f3.svg";